import React, { useEffect, useState } from "react";
import MyProfileAudienceReach from "./MyProfileAudienceReach";
import { SelectInput } from "../../Components";
import MyProfileAbout from "./MyProfileAbout";
import MyProfileUploader from "./MyProfileUploader";
import { useNavigate } from "react-router-dom";
import GalleryGridItem from "./GalleryGridItem";

const genderList = [
  { id: "m", value: "Male", apiCode: "m" },
  { id: "f", value: "Female", apiCode: "f" },
  { id: "o", value: "Other", apiCode: "o" },
  { id: "x", value: "Prefer not to say", apiCode: "x" },
];

export default function MyProfileListing({
  setShowConfirmInfModal,
  setIndexForAction,
  setShowConfirmDelete,
  newGalleryUploaded,
  countOfImage,
  uploadFile,
  galleryList,
  error,
  form,
  categories,
  categoriesData,
  setBio,
  refAbout,
  setInput,
  saveChanges,
  refInfo,
  updateForm,
  countries,
  states,
  enterCalled,
  refShip,
  PublicProfileData,
}) {
  console.log(
    "🚀 ~ MyProfileListing ~ newGalleryUploaded:",
    newGalleryUploaded
  );
  const [croppedImage, setCroppedImage] = useState(null);
  const navigate = useNavigate();

  const viewFullGallery = () => {
    navigate("/influencer/gallery");
  };

  useEffect(() => {
    if (croppedImage) {
      updateForm({ uploaded_profile_photo: croppedImage });
    }
  }, [croppedImage]);

  const selectCountryList = React.useMemo(() => {
    if (!countries) return [];

    return countries.map((country) => ({
      id: String(country.id),
      value: country.name,
      code: country.code,
    }));
  }, [countries]);

  const selectedCountry = React.useMemo(() => {
    if (
      !form.country_id ||
      form.country_id === "" ||
      form.country_id === null
    ) {
      return null;
    }

    const countryId = String(form.country_id);
    return (
      selectCountryList.find((item) => String(item.id) === countryId) || null
    );
  }, [form.country_id, selectCountryList]);

  const selectedGender = React.useMemo(() => {
    if (!form.gender || form.gender === "" || form.gender === null) {
      return null;
    }

    return (
      genderList.find((item) => String(item.apiCode) === String(form.gender)) ||
      null
    );
  }, [form.gender, genderList]);

  const handleSelectChange = (key) => (selectedItem) => {
    if (!selectedItem) {
      console.warn("Selected item is null or undefined");
      updateForm({ [key]: "" });
      return;
    }
    const newValue = selectedItem;

    if (newValue === undefined) {
      console.error(
        "Selected item ID is undefined. Item structure might be incorrect."
      );
      return;
    }

    setShowConfirmInfModal(true);
    updateForm({ [key]: newValue });
  };
  console.log("🚀 ~ PublicProfileData:", PublicProfileData);

  return (
    <div className="space-y-8">
      {/* Basic Information Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Display Name */}
        <div className="space-y-3">
          <label className="block text-sm font-semibold text-emerald-900">
            Display name <span className="text-red-400">*</span>
          </label>
          <div className="relative group">
            <input
              value={form.displayname || ""}
              type="text"
              onChange={setInput("displayname")}
              className={`w-full px-5 py-4 border border-emerald-100 rounded-2xl focus:ring-4 focus:ring-emerald-200 focus:border-emerald-400 transition-all duration-300 bg-white/80 backdrop-blur-sm placeholder-emerald-300 ${
                error && !form.displayname ? "border-red-500" : ""
              }`}
              placeholder="Enter your display name"
            />
            <div className="absolute inset-y-0 right-0 flex items-center pr-4">
              <svg
                className="w-5 h-5 text-emerald-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
            </div>
          </div>
          {error && !form.displayname && (
            <p className="text-red-500 text-sm mt-1 flex items-center gap-2">
              Please enter Display name
            </p>
          )}
        </div>

        {/* Link Tree */}
        <div className="space-y-3">
          <label className="block text-sm font-semibold text-emerald-900">
            Link tree
          </label>
          <div className="relative group">
            <input
              value={form.linktree || ""}
              type="text"
              onChange={setInput("linktree")}
              className="w-full px-5 py-4 border-2 border-emerald-100 rounded-2xl focus:ring-4 focus:ring-emerald-200 focus:border-emerald-400 transition-all duration-300 bg-white/80 backdrop-blur-sm placeholder-emerald-300"
              placeholder="Enter your link tree URL"
            />
            <div className="absolute inset-y-0 right-0 flex items-center pr-4">
              <svg
                className="w-5 h-5 text-emerald-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Country & Gender Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Country Select Input */}
        <div className="space-y-3">
          <label className="block text-sm font-semibold text-emerald-900">
            Country <span className="text-red-400">*</span>
          </label>
          <SelectInput
            // label="Country"
            value={form.country_id}
            list={selectCountryList}
            selected={selectedCountry}
            onChange={handleSelectChange("country_id")}
            error={
              error &&
              (!form.country_id ||
                form.country_id === "" ||
                form.country_id === 0)
            }
            // errorText="Please select Country"
            isRequired
            className={`w-full px-5 py-4 border border-emerald-100 rounded-2xl focus:ring-4 focus:ring-emerald-200 focus:border-emerald-400 transition-all duration-300 bg-white/80 backdrop-blur-sm ${
              error && !form.country_id ? "border-red-500 !mb-0" : ""
            }`}
          />
          {error && !form.country_id && (
            <p className="text-red-500 text-sm flex !mt-0 items-center gap-2">
              Please select Country
            </p>
          )}
        </div>

        {/* Gender Select Input */}
        <div className="space-y-3">
          <label className="block text-sm font-semibold text-emerald-900">
            Gender <span className="text-red-400">*</span>
          </label>
          <SelectInput
            // label="Gender"
            value={form.gender}
            list={genderList}
            selected={selectedGender}
            onChange={handleSelectChange("gender")}
            error={error && !form.gender}
            // errorText="Please select Gender"
            isRequired
            className={`w-full px-5 py-4 border border-emerald-100 rounded-2xl focus:ring-4 focus:ring-emerald-200 focus:border-emerald-400 transition-all duration-300 bg-white/80 backdrop-blur-sm ${
              error && !form.gender ? "border-red-500 !mb-0" : ""
            }`}
          />
          {error && !form.gender && (
            <p className="text-red-500 text-sm flex !mt-0 items-center gap-2">
              Please select Gender
            </p>
          )}
        </div>
      </div>

      {/* Profile Photo Section */}
      <div className="space-y-3">
        <label className="block text-sm font-semibold text-emerald-900">
          Profile photo <span className="text-red-400">*</span>
        </label>
        <MyProfileUploader
          form={form}
          croppedImage={croppedImage}
          setCroppedImage={setCroppedImage}
          setShowConfirmInfModal={setShowConfirmInfModal}
        />
      </div>

      {/* About Section */}
      <div className="bg-white overflow-hidden">
        <MyProfileAbout
          form={form}
          setInput={setInput}
          updateForm={updateForm}
          saveChanges={saveChanges}
          categories={categories}
          categoriesData={categoriesData || []}
          setBio={setBio}
          enterCalled={enterCalled}
          refAbout={refAbout}
          error={error}
          setShowConfirmInfModal={setShowConfirmInfModal}
        />
      </div>

      {/* Audience Reach Section */}
      <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl p-8 border-2 border-emerald-100/50">
        <MyProfileAudienceReach
          setShowConfirmInfModal={setShowConfirmInfModal}
          form={form}
          error={error}
          updateForm={updateForm}
        />
      </div>

      {/* Gallery Section */}

      <div className="bg-white rounded-2xl border-2 border-emerald-100 p-8">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between mb-8 gap-4">
          <div>
            <h6 className="text-xl font-bold text-emerald-900 mb-2">
              Gallery images <span className="text-red-400">*</span>
            </h6>
            <p className="text-emerald-700">
              {PublicProfileData?.media_needed === 0 ? (
                <>
                  You've uploaded {countOfImage}/3 images. Your initial gallery
                  is complete!{" "}
                  <p
                    className="underline mt-2 text-emerald-800 cursor-pointer"
                    onClick={viewFullGallery}
                  >
                    View gallery to Upload More Photos
                  </p>
                </>
              ) : (
                "Showcase your best work with at least 3 high-quality images"
              )}
            </p>
          </div>
          <div
            className={`px-4 py-2 rounded-full text-sm font-semibold border-2 ${
              countOfImage >= 3
                ? "bg-emerald-100 text-emerald-800 border-emerald-200"
                : "bg-amber-100 text-amber-800 border-amber-200"
            }`}
          >
            {countOfImage}/3 images uploaded
          </div>
        </div>
        {PublicProfileData?.media_needed !== 0 ||
        PublicProfileData?.media_needed === undefined ? (
          <>
            {/* Progress Indicator */}
            <div className="mb-8">
              <div className="flex items-center justify-between text-sm text-emerald-700 mb-2">
                <span>Gallery completion</span>
                <span>{Math.min(countOfImage, 3)}/3</span>
              </div>
              <div className="w-full bg-emerald-100 rounded-full h-3">
                <div
                  className="bg-gradient-to-r from-emerald-500 to-teal-500 h-3 rounded-full transition-all duration-500"
                  style={{ width: `${(Math.min(countOfImage, 3) / 3) * 100}%` }}
                ></div>
              </div>
            </div>

            {/* Gallery Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
              {galleryList.map((item, index) => (
                <div key={index} className="group relative">
                  <GalleryGridItem {...item} />
                  <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-300 rounded-2xl" />
                </div>
              ))}

              {newGalleryUploaded.map((item, index) => (
                <GalleryGridItem
                  key={index}
                  setShowConfirmInfModal={setShowConfirmInfModal}
                  media_type_id={item.media_type_id}
                  media_url={item.mediafile}
                  status={"visible"}
                  newAddedImage={true}
                  {...item}
                  indexForItem={index}
                  setIndexForAction={setIndexForAction}
                  setShowConfirmDelete={setShowConfirmDelete}
                />
              ))}

              {/* Add File Button */}
              {countOfImage + newGalleryUploaded?.length < 3 && (
                <div
                  onClick={uploadFile}
                  className="border-3 border-dashed border-emerald-200 rounded-2xl flex flex-col items-center justify-center p-12 cursor-pointer hover:border-emerald-400 hover:bg-emerald-25 transition-all duration-300 group"
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-emerald-100 to-teal-100 rounded-2xl flex items-center justify-center mb-4 group-hover:from-emerald-200 group-hover:to-teal-200 transition-all duration-300 shadow-lg">
                    <svg
                      className="w-8 h-8 text-emerald-500 group-hover:scale-110 transition-transform"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4v16m8-8H4"
                      />
                    </svg>
                  </div>
                  <span className="text-emerald-700 font-semibold text-lg">
                    Add Image
                  </span>
                  <span className="text-emerald-500 text-sm mt-2">
                    PNG, JPG, GIF up to 10MB
                  </span>
                </div>
              )}

              {/* View Full Gallery Button */}
              {countOfImage >= 3 && (
                <div className="flex items-center justify-center col-span-full">
                  <button
                    onClick={viewFullGallery}
                    className="px-8 py-4 bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-xl hover:from-emerald-600 hover:to-teal-600 focus:ring-4 focus:ring-emerald-200 focus:ring-offset-2 transition-all duration-300 font-semibold shadow-lg hover:shadow-xl hover:scale-105 transform flex items-center gap-3"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 6a2 2 0 012-2h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 10l2 2 4-4"
                      />
                    </svg>
                    View Full Gallery
                  </button>
                </div>
              )}
            </div>
          </>
        ) : PublicProfileData?.media_needed === 0 ? (
          <p></p>
        ) : null}
        {countOfImage + newGalleryUploaded.length < 3 && error && (
          <div className="bg-red-50 border border-red-200 rounded-xl p-4 flex items-center gap-3">
            <svg
              className="w-5 h-5 text-red-500 flex-shrink-0"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
            <p className="text-red-700 text-sm">
              Please add at least 3 gallery images to complete your profile
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
